'use client'

import { useFilterStore, useMapStore } from '../../../../state-library/src'
import EmptyStateIcon from './EmptyStateIcon'
import { EPropertyType } from '../../../../types-library/src'

export const CDMX_PROPERTIES = {
  id: '09',
  alias: 'cdmx',
  lng: -99.1394,
  lat: 19.2769,
}
interface Props {
  className?: string
  onCleanSearch?: () => void
}

/**
 * This component is used to show the empty state when the search does not return any result
 * @returns {JSX.Element}
 */
const EmptyState = ({ className = '', onCleanSearch }: Props): JSX.Element => {
  const {
    setOpportunityCriteria,
    setRooms,
    setBathrooms,
    setParkings,
    setPriceFrom,
    setPriceTo,
    setAreaBounds,
    setAmenities,
    setShowOnlyCommissionProperties,
    setAgencyId,
    setAssociationIds,
    setCommissionRateHighRange,
    setCommissionRateLowRange,
    setSurfaceFrom,
    setSurfaceTo,
    setSearchAddress,
    setConstructionType,
    setPropertyType,
    setLatitude,
    setLongitude,
    setWiggotUserType,
    setListingsSource,
  } = useFilterStore((state) => state)
  const { setDrawingTool } = useMapStore()

  const cleanFilters = (): void => {
    setOpportunityCriteria(undefined)
    setRooms(0)
    setBathrooms(0)
    setParkings(0)
    setPriceFrom(0)
    setPriceTo(0)
    setAreaBounds([])
    setDrawingTool({
      isActive: false,
      status: undefined,
    })
    setAmenities([])
    setShowOnlyCommissionProperties(false)
    setAgencyId(undefined)
    setAssociationIds(undefined)
    setCommissionRateHighRange(0)
    setCommissionRateLowRange(0)
    setSurfaceFrom(undefined)
    setSurfaceTo(undefined)
    setSearchAddress(undefined)
    setConstructionType(undefined)
    setPropertyType(EPropertyType.SALE)
    setLatitude(19.4195256)
    setLongitude(-99.162549)
    setWiggotUserType('macrobolsa')
    setListingsSource('wiggot')
    onCleanSearch?.()
  }
  return (
    <div
      className={`w-full h-full flex justify-center items-center ${className}`}
    >
      <div className="flex flex-col gap-4">
        <div className="flex justify-center">
          <EmptyStateIcon />
        </div>
        <article className="flex flex-col justify-center text-base font-semibold ">
          <p className="font-semibold text-center">
            No encontramos propiedades
          </p>
          <p className="font-semibold text-center">
            que coincidan con tu búsqueda actual
          </p>
        </article>

        <div className="">
          <p className="text-sm font-medium text-center text-secondary">
            Prueba eliminando alguno de los filtros que utilizaste
          </p>
        </div>

        <div className="flex justify-center">
          <button
            onClick={cleanFilters}
            className="!h-[52px] !py-0 !px-4 rounded-full !bg-primary !text-white !font-semibold !text-sm !flex !items-center !justify-center !gap-2"
          >
            Limpiar búsqueda
          </button>
        </div>
      </div>
    </div>
  )
}

export default EmptyState
